import { type ForwardedRef, forwardRef, memo } from 'react';

import { UserOutlined } from '@ant-design/icons';
import { Avatar } from 'antd';
import cn from 'classnames';

import { useViewerAvatar } from '../../model/selectors/viewer-avatar';

type ViewerAvatarSize = 40 | 48 | 72 | 80;

interface ViewerAvatarProps {
    // eslint-disable-next-line react/no-unused-prop-types
    size?: ViewerAvatarSize;
    // eslint-disable-next-line react/no-unused-prop-types
    className?: string;
}

export const ViewerAvatar = memo(
    forwardRef(
        (props: ViewerAvatarProps, ref: ForwardedRef<HTMLSpanElement>) => {
            const { size = 40, className, ...dropdownProps } = props;

            const avatarSource = useViewerAvatar();

            return (
                <Avatar
                    /* eslint-disable-next-line react/jsx-props-no-spreading */
                    {...dropdownProps}
                    ref={ref}
                    className={cn(className)}
                    icon={<UserOutlined />}
                    size={size}
                    src={avatarSource}
                />
            );
        },
    ),
);

ViewerAvatar.displayName = 'ViewerAvatar';
